// extracted by mini-css-extract-plugin
export default {"jumbo":"jumbo__GXHQZ","subtitle":"subtitle__llxEo","subscribeSubtitle":"subscribeSubtitle__uM8iH","moreLink":"moreLink__G2RZc"};